module.exports = __webpack_public_path__ + "static/media/claude-logo.e061148b.svg";